import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard } from '@coreui/react'
import { raiseToast } from '../../../utils/helper'
import useAxios from 'axios-hooks'
import { AppContext } from '../../../context/app'
import { isEmpty } from 'lodash'
import EditIcon from '../../../../assets/edit-svg-black.svg'
import AddIcon from '../../../../assets/addnew-icon2.svg'
import FormListCard from '../../customForms/formListCard'
import { useHistory } from 'react-router-dom'
import { EMAIL_TEMPLATE_API } from '../../../utils/urls'
import AssetFilter from '../../AssetManager/AssetFilter'

const CampaignEmailTemplateList = () => {
  const { setLoader } = useContext(AppContext)
  const history = useHistory()
  const [templateData, setTemplateData] = useState('')

  const [{ data: templateList, loading: templateDataLoading }, templateListCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: templateUpdate, loading: templateUpdateLoading }, templateUpdateCall] = useAxios(
    {
      url: EMAIL_TEMPLATE_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    templateListCall()
  }, [])

  useEffect(() => {
    setLoader(templateDataLoading || templateUpdateLoading)
  }, [templateDataLoading, templateUpdateLoading])

  useEffect(() => {
    if (templateList && templateList.success) {
      setTemplateData(templateList.data.filter((info) => !info?.is_system_defined))
    }
  }, [templateList])

  useEffect(async () => {
    if (templateUpdate && templateUpdate.success) {
      await templateListCall()
      raiseToast('success', 'Email Template Updated Successfully!')
    }
  }, [templateUpdate])

  const handleStatus = (status, id) => {
    templateUpdateCall({
      params: {
        email_template_id: id,
      },
      data: { status: status },
    })
  }

  const handleEdit = (info) => {
    history.push(`/campaign/mail-templates/edit/${info._id}`)
  }

  const handleSearch = () => {}

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Email Templates</h4>
          <p>Following are the Templates which are already in your store.</p>
        </div>
        <CButton
          className="text-white px-3"
          onClick={() => {
            history.push('/campaign/mail-templates/create')
          }}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          + Add New Template
        </CButton>
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 3vh',
          width: '100%',
        }}
      >
        <div>
          <AssetFilter
            onSearch={handleSearch}
            dropdownHeight={'300px'}
            disableFilter={true}
            searchStyle={{ background: '#fff' }}
          />
        </div>
      </div>
      <CCard>
        <div>
          <div id="scrollableDiv" className="asset-manager-card position-relative">
            <div
              className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
              style={{
                fontSize: 'max(0.63vw,10px)',
                paddingTop: '2px',
                paddingBottom: '2px ',
                top: '0',
                zIndex: '10',
              }}
            >
              <div style={{ width: '100%' }} className="d-flex align-items-center">
                <div style={{ marginBlockEnd: '0', width: '20%' }} className="pl-2">
                  Template Name
                </div>
                <div style={{ marginBlockEnd: '0', width: '20%' }}>Type</div>
                <div style={{ marginBlockEnd: '0', width: '25%' }}>Subject</div>
                <div style={{ marginBlockEnd: '0', width: '20%' }}>Created On</div>
                <div style={{ marginBlockEnd: '0', width: '10%', textAlign: 'center' }}>Status</div>
                <div style={{ width: '5%' }} />
              </div>
            </div>

            <div
              className="d-flex flex-wrap"
              style={{
                gap: '1.2vw 0',
                padding: '30px 8px 20px 8px',
              }}
            >
              {!isEmpty(templateData)
                ? templateData.map((info, index) => {
                    return (
                      <FormListCard
                        cardImage={''}
                        cardImgWidth="0%"
                        disableCardImg={true}
                        textData={[
                          {
                            name: info?.name,
                            styles: {
                              overflow: 'hidden',
                              fontWeight: '600',
                              fontSize: '14px',
                              width: '20%',
                              paddingLeft: '10px',
                            },
                          },
                          {
                            name: info?.template_type,
                            styles: { width: '20%' },
                          },
                          {
                            name: info?.subject,
                            styles: { width: '25%' },
                          },
                          {
                            name: new Date(info?.created_date).toISOString().split('T')[0],
                            styles: { width: '20%' },
                          },
                        ]}
                        key={index}
                        status={info?.status}
                        statusCallback={(value) => {
                          handleStatus(value, info._id)
                        }}
                        actionButtonOptions={[
                          {
                            name: 'Edit',
                            btnFunction: () => handleEdit(info),
                            logo: (
                              <div className="flex mr-1">
                                <img style={{ width: '10px' }} src={EditIcon} alt={'editIcon'} />
                              </div>
                            ),
                          },
                        ]}
                        actionButtonWidth="5%"
                      />
                    )
                  })
                : null}

              <div
                style={{
                  width: '100%',
                  aspectRatio: '1506/71',
                  boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                  display: 'flex',
                  background: '#ececec',
                  fontSize: '0.833vw',
                  fontWeight: 550,
                }}
                className={`rounded-1 cursor-pointer d-flex flex-col justify-content-center align-items-center`}
                onClick={() => {
                  history.push('/campaign/mail-templates/create')
                }}
              >
                <img
                  src={AddIcon}
                  alt="AddIcon"
                  className=""
                  style={{ width: '1.25vw', height: '1.25vw' }}
                />
                <span className="">Add New Template</span>
              </div>
            </div>
          </div>
        </div>
      </CCard>
    </>
  )
}

export default CampaignEmailTemplateList
